import { Info } from "lucide-react";
import styles from "./analytics.module.scss";

function SmallerDataItem({ data }) {

    return (
        <div className={styles.smallerDataItem} style={{ width: "32.6%" }}>
            <div className={styles.top}>
                <p className={styles.label}>{data.label}</p>
                {data.info &&
                    <div className={styles.infoContainer}>
                        <Info className={styles.icon} />
                        <p className={styles.tooltip}>{data.info}</p>
                    </div>}

            </div>
            <p className={styles.value}>{data.value}</p>
        </div>
    );
}

export default SmallerDataItem;
